import { render, staticRenderFns } from "./FourSeasonsTab.vue?vue&type=template&id=6b824ec6"
import script from "./FourSeasonsTab.vue?vue&type=script&lang=js"
export * from "./FourSeasonsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports